export const COPYTRADE = {
	page: 'copytrade-page',
	cta: 'copytrade-cta',
	video: 'copytrade-video',
	adminPage: 'admin-copytrade-page',
	adminNewBtn: 'admin-copytrade-new',
	adminSaveBtn: 'admin-copytrade-save',
	adminRow: 'admin-copytrade-row',
	publishToggle: 'admin-copytrade-publish',
};
